/**
 * Resolve an image URL coming from the backend.
 * Supports:
 *  - Absolute URLs (Cloudinary CDN, external): returned as-is
 *  - Relative URLs (/api/static/...): prefixed with BACKEND_URL
 *  - Empty/null: returned as-is
 */
export function resolveImageUrl(url, backendUrl) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith("data:")) return url;
  return `${backendUrl}${url}`;
}
